import { Component, OnInit } from '@angular/core';
import * as AOS from 'aos';
import {Title } from "@angular/platform-browser";
//jquery declaration
declare var $: any;

@Component({
  selector: 'app-safetyprogram',
  templateUrl: './safetyprogram.component.html',
  styleUrls: ['./safetyprogram.component.css']
})
export class SafetyprogramComponent implements OnInit {

  constructor(
    private titleService: Title,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle("Safety Program - SFI Compliance, Inc");
    this.topposition();
    AOS.init();

  }

  //scroll to top of the page automatically
  topposition() {
    $('html, body').animate({
      scrollTop: 0
    }, 1000, 'easeInOutExpo');

    return false;
  }

}
